export const POPULAR_EVENTS_FETCH_PENDING = 'POPULAR_EVENTS_FETCH_PENDING';
export const POPULAR_EVENTS_FETCH_SUCCESS = 'POPULAR_EVENTS_FETCH_SUCCESS';
export const POPULAR_EVENTS_FETCH_ERROR = 'POPULAR_EVENTS_FETCH_ERROR';
